'use client';

import { createContext } from 'react';

import type { ProgressStepperStepContextInterface } from '../types/progress-stepper-step.types';

export const ProgressStepperStepContext = createContext<ProgressStepperStepContextInterface>({});

ProgressStepperStepContext.displayName = 'ProgressStepper.Step.Context';
